import { AxiosError } from 'axios';
import type { ApiError, PriorityLimitDetails } from '@pms/shared';

/** Extracts the human-readable message from a backend error envelope. */
export function getErrorMessage(e: unknown): string {
  return (e as AxiosError<ApiError>).response?.data?.error?.message ?? 'Something went wrong';
}

/**
 * The priority-cap payload, or null for every other failure.
 *
 * `error.details` is a shared slot, so this checks the `kind` discriminator rather than
 * assuming a shape — a different error's payload must not be rendered as this one. Callers
 * fall back to `getErrorMessage` when it returns null.
 */
export function getPriorityLimitDetails(e: unknown): PriorityLimitDetails | null {
  const details = (e as AxiosError<ApiError>).response?.data?.error?.details;
  return (details as PriorityLimitDetails | undefined)?.kind === 'priority_task_limit'
    ? details as PriorityLimitDetails
    : null;
}
